// extracted by mini-css-extract-plugin
export var optionGrid = "_bi-7";
export var optionList = "_bi-6";
export var questionsBlock = "_bi-9";
export var spacer = "_bi-5";
export var stepCenteredContent = "_bi-3";
export var stepInner = "_bi-0";
export var stepInnerFullWidth = "_bi-1";
export var stepInnerLockScroll = "_bi-2";
export var stepTransitionFrame = "_bi-4";
export var welcomeBlock = "_bi-8";